module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1XqNCU/tc-custom/9781416503712.jpg?1730494023322",
      "alt": "This image is the cover for the book Book of the Sword, Samurai Girl"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Book of the Sword, Samurai Girl\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When I was six months old, I dropped from the sky -- the lone survivor of a deadly Japanese plane crash. The newspapers called me Heaven. I was adopted by a wealthy family in Tokyo, pampered, and protected. For nineteen years, I thought I was lucky. "), _c('br'), _c('br'), _vm._v(" I'm learning how wrong I was.")]), _c('br'), _c('br'), _c('b', [_vm._v("They say your life begins on your wedding day.")]), _c('br'), _c('br'), _vm._v(" Here's what happened on mine: "), _c('br'), _vm._v("I lost the person I love most. "), _c('br'), _vm._v("I learned that everything I knew about my family was a lie. "), _c('br'), _vm._v("Now I'm being hunted. I must fight back, or die. "), _c('br'), _c('br'), _vm._v(" My life ended that day. "), _c('br'), _vm._v("The old Heaven is gone. "), _c('br'), _c('br'), _c('b', [_vm._v("I AM SAMURAI GIRL.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carrie Asai\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carrie Asai is the author of The Book of the Heart, a Simon & Schuster book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Simon Pulse\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0